import { RocheUIPublishedDate } from '@repo/roche-ui';
import React, { useContext, useEffect, useState } from 'react';
import { BaseBlok, BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { useTranslation } from '../../hooks/use-translation';
import { StoryTeaserService } from '../../services/story-teaser';
import { DateFormattingService } from '../../services/date-time-formatter';
import { RocheXXTranslationContext } from '../../contexts/translation';

type RochePublishedDateType = BlokToComponentProps<BaseBlok>;

export const RochePublishedDate = ({ blok, storyId, updateHoistedState }: RochePublishedDateType): JSX.Element => {
  const [date, setDate] = useState<string | null>(null);
  const publishedTranslation = useTranslation('published');
  const translations = useContext(RocheXXTranslationContext);

  useEffect(() => {
    if (!storyId) {
      return;
    }
    const { _uid: uid } = blok;
    if (!blok.preRenderContent) {
      StoryTeaserService.getStoryTeaser(storyId as number).then(async (result) => {
        const publishedDate = result?.first_published_at || '';

        const formattedDate =
          publishedDate && typeof document !== 'undefined'
            ? DateFormattingService.formatDate(publishedDate, 'dateFull', translations)
            : null;
        setDate(formattedDate);
        updateHoistedState?.(1, 1, uid, result);
      });
    } else {
      const publishedDate = blok?.preRenderContent?.first_published_at || '';
      const formattedDate = DateFormattingService.formatDate(publishedDate, 'dateFull', translations);
      setDate(formattedDate);
      updateHoistedState?.(1, 1, uid, formattedDate);
    }
  }, [translations]);

  const concatenatedString = date ? `${publishedTranslation} ${date}` : publishedTranslation;

  return <RocheUIPublishedDate publishedDate={concatenatedString} />;
};
